import { I18n } from "@assets/strings";
import React from "react";
import { useHistory } from "@core/routing/useHistory";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { GroupDraft } from "@domain/group/groupDraft";
import { ClosableModal } from "@ui/modals/closableModal";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { SecondaryButton } from "@ui/components/buttons/secondaryButton";
import { Description } from "@ui/components/containers/description";
import { PrimaryBold } from "@ui/components/containers/primary";
import { Row, stack } from "@ui/components/layout";

interface ShareroomEditorCancelModalProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: GroupDraft;
	close: () => void;
}

export const ShareroomEditorCancelModal: React.FC<ShareroomEditorCancelModalProps> = ({
	shareroom,
	close,
	...htmlProps
}) => {
	const { name } = shareroom;
	const history = useHistory();
	return (
		<Container close={close} {...htmlProps}>
			<StyledPrimaryBold>{I18n.t("shareroom.edit.cancel_modal.title", { name })}</StyledPrimaryBold>
			<PrimaryBold>{I18n.t("shareroom.edit.cancel_modal.big_title")}</PrimaryBold>
			<Description>{I18n.t("shareroom.edit.cancel_modal.description")}</Description>
			<Row gap={15}>
				<SecondaryButton onClick={() => close()}>{I18n.t("shareroom.edit.back")}</SecondaryButton>
				<PrimaryButton onClick={() => history.push(Path.Root)}>{I18n.t("group.edit.quit")}</PrimaryButton>
			</Row>
		</Container>
	);
};

const Container = styled(ClosableModal)`
	${stack(40, "center", "center")}
	text-align: center;
`;

const StyledPrimaryBold = styled(PrimaryBold)`
	color: ${({ theme }) => theme.colors.secondary};
`;
